import { Link } from 'react-router-dom'

const Breadcrumb = ({ crumbs }) => {
    const isTeacher = window.location.pathname.includes('teacher')
    const isAdmin = window.location.pathname.includes('admin')
    function isLast(index) {
        return index === crumbs.length - 1;
    }
    return (
        <div style={{ marginTop: "1rem", marginBottom: "2rem" }}>
            <ul className="breadcrumb">
                <li>
                    {isTeacher ?
                        (
                            <Link to="/teacher/dashboard">Home</Link>
                        )
                        : isAdmin ? (

                            <Link to="/admin/dashboard">Home</Link>
                        ) : (
                            <Link to="/student/dashboard">Home</Link>
                        )
                    }
                </li>
                {
                    crumbs.map((crumb, ci) => {
                        const disabled = isLast(ci);

                        return (
                            <li
                                key={ci}

                            >
                                {disabled ? (
                                    <span>
                                        {crumb}
                                    </span>
                                ) : (

                                    isTeacher ? (
                                        <Link to={`/teacher/${crumb}`.toLowerCase()} > {crumb}</Link>
                                    ) : isAdmin ? (
                                        <Link to={`/admin/${crumb}`.toLowerCase()} >{crumb}</Link>
                                    ) : (
                                        <Link to={`/student/${crumb}`.toLowerCase()} >{crumb}</Link>
                                    )

                                )}
                            </li>
                        );
                    })
                }
            </ul>
        </div >
    )
}

export { Breadcrumb }

